import Domen from "../../../stores/Domen";

export async function getLinkOutline() {
    const token = localStorage.getItem("token");
    localStorage.setItem("countactivetime", Date.now());

    const response = await fetch(Domen.url + `portraits/table/deploy/csv`, {
        method: 'GET',
        headers: {
            'Authorization': token,
            'Content-Type': 'application/json',
        }
    });

    if (response.status === 200) {
        const data = await response.json();
        if (data?.download_url) {
            window.location.href = data.download_url;
        }
    } else {
        console.error("Помилка отримання посилання на CSV:", response.status);
    }
}
